import React from 'react'
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_URI,
    // uri: 'http://localhost:7071/graphql',
    cache: new InMemoryCache({
        addTypename: false,
    }),
    connectToDevTools: true,
})

const GraphqlProvider = ({ children }) => {
    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export { client, GraphqlProvider }
